<template>
    <b-card class="mb-5">
        <b-row>
            <b-col md="12">
                <b-row class="mt-0 mb-0">
                    <b-col md="12">
                        <b-alert show>
                            <b>Leave for {{ theseYears }}.</b> <a href="#/leave" style="font-size:14px!important; color:#0056b3!important; text-decoration:underline!important;">View all</a>
                        </b-alert>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <paginated-table ref="dataTable" :can-show="true" :can-show-route-path="'#/leave'" :can-paid="false" :can-approve="false" :can-reject="false" :can-delete="false" :can-edit="false" :data-url="apiUrl.leave" :data-key="dataKey" :data-columns="columns">
        </paginated-table>
    </b-card>
</template>
<script>
    import PaginatedTable from '@/components/PaginatedTable'
    export default {
        props: {
            profileUuid: {
                type: String,
                required: false
            }
        },
        name: 'leave-index',
        components: {
            PaginatedTable
        },
        data: function() {
        var currentDate = new Date();
        var twoDigitFirstMonth= '01';
        var twoDigitFirstDate= '01';
        var createdDateTo = currentDate.getFullYear() + "-" + twoDigitFirstMonth + "-" + twoDigitFirstDate;
        
        var currentDate = new Date();
        var twoDigitLastMonth= '12';
        var twoDigitLastDate= '31';
        var createdDateBy = currentDate.getFullYear() + "-" + twoDigitLastMonth + "-" + twoDigitLastDate;

        var theseYears = currentDate.getFullYear();

            return {
                dataKey: 'leave',
                apiUrl: {
                    leave : window.AppConfig.apiUrl + 'leave?requested_by=' + this.profileUuid + '&start_date=' + createdDateTo + '&end_date=' + createdDateBy
                },
                theseYears: theseYears,
                createdDateTo: createdDateTo,
                createdDateBy: createdDateBy,
                columns: [
                    {
                        key: 'requestedByName',
                        label: 'Employee',
                        sortable: true
                    },
                    {
                        key: 'startDate',
                        label: 'Start Date',
                        sortable: true
                    },
                    {
                        key: 'endDate',
                        label: 'End Date',
                        sortable: true
                    },
                    {
                        key: 'days',
                        label: 'Days',
                        sortable: true
                    },
                    {
                        key: 'leaveType',
                        label: 'Type',
                        sortable: true
                    },
                    {
                        key: 'requestedByDepartment',
                        label: 'Department',
                        sortable: true
                    },
                    {
                        key: 'note',
                        label: 'Note'
                    },
                    {
                        key: 'status',
                        label: 'Status'
                    },
                    {
                        key: 'actionLeaves',
                        label: ''
                    }
                ]
            }
        },
        methods: {
            getDateTime (value) {
                if (value !== null) {
                    return this.$moment(value).format('YYYY-MM-DD HH:mm')
                } else {
                    return '-'
                }
            }
        }
    }
</script>